// Qué decirle al médico cuando el dictado no pudo abrir el micrófono.
//
// Por qué existe: ante un permiso denegado el Turno decía "Falló el dictado en
// streaming. Probá de nuevo." — y probar de nuevo NO sirve: una vez que el
// navegador guardó el "Bloquear", getUserMedia rechaza al instante sin volver a
// preguntar. El médico reintentaba, fallaba igual y dejaba de dictar (sep-2026,
// Tomás Oviedo: 2 intentos, 0 dictados). El nombre del error dice qué hacer, y
// el paso depende del aparato, así que el mensaje lo dice con el camino exacto.

function entorno(ua, toques) {
  const s = String(ua || "");
  // El iPad con Safari se presenta como Mac: lo delata que tiene pantalla táctil.
  const ios = /iPhone|iPad|iPod/i.test(s) || (/Macintosh/i.test(s) && (/Mobile/i.test(s) || toques > 1));
  return {
    // Los navegadores internos de WhatsApp/Instagram/Facebook/Gmail no exponen el
    // permiso de micrófono: ahí no hay ajuste que tocar, hay que salir de la app.
    appInterna: /FBAN|FBAV|Instagram|WhatsApp|Line\/|GSA\//i.test(s),
    ios,
    iosChrome: ios && /CriOS/i.test(s),
    android: /Android/i.test(s),
    mac: /Macintosh/i.test(s) && !ios,
    safariMac: /Macintosh/i.test(s) && !ios && /Safari/i.test(s) && !/Chrome|Chromium|CriOS|Edg|Firefox|OPR/i.test(s),
  };
}

const NAV = typeof navigator !== "undefined" ? navigator : {};

export function mensajeErrorMicrofono(err, ua = NAV.userAgent || "", toques = NAV.maxTouchPoints || 0) {
  const nombre = String(err?.name || "");
  const e = entorno(ua, toques);

  if (nombre === "NotAllowedError" || nombre === "SecurityError") {
    if (e.appInterna) {
      return "Este navegador interno no deja usar el micrófono. Abre SmartDx en Safari o Chrome.";
    }
    if (e.iosChrome) {
      return "El micrófono está bloqueado. En el iPhone: Ajustes → Chrome → activa Micrófono, y recarga la página.";
    }
    if (e.ios) {
      return "El micrófono está bloqueado para SmartDx. En Safari toca «aA» en la barra de dirección → Configuración del sitio web → Micrófono → Permitir, y recarga la página.";
    }
    if (e.android) {
      return "El micrófono está bloqueado para SmartDx. En Chrome toca el ícono a la izquierda de la dirección → Permisos → Micrófono → Permitir, y recarga la página.";
    }
    if (e.safariMac) {
      return "El micrófono está bloqueado para SmartDx. En Safari: menú Safari → Configuración para este sitio web → Micrófono → Permitir, y recarga la página.";
    }
    const base = "El micrófono está bloqueado para SmartDx. Haz clic en el ícono a la izquierda de la dirección → Micrófono → Permitir, y recarga la página.";
    return e.mac
      ? `${base} Si ya estaba permitido: Ajustes del Sistema → Privacidad y seguridad → Micrófono → activa tu navegador.`
      : base;
  }
  if (nombre === "NotFoundError" || nombre === "OverconstrainedError") {
    return "No se encontró un micrófono. Conecta uno o revisa que el equipo lo reconozca.";
  }
  if (nombre === "NotReadableError") {
    return "Otra app está usando el micrófono (Zoom, Teams, una llamada). Ciérrala y prueba de nuevo.";
  }
  // Sin navigator.mediaDevices (webview vieja, página fuera de https) no hay
  // micrófono que pedir: reintentar tampoco sirve.
  if (nombre === "NotSupportedError" || (nombre === "TypeError" && !NAV.mediaDevices?.getUserMedia)) {
    return "Este navegador no permite usar el micrófono. Abre SmartDx en Safari o Chrome.";
  }
  return null;
}
